import { DOCUMENT_RECONSTRUCTION } from '../constants/config';

/**
 * Reconstructs document content from Azure Document Intelligence analysis result
 * @param {Object} analyzeResult - The analysis result from Azure Document Intelligence
 * @param {number} widthChars - Character width for the grid
 * @param {number} heightLines - Line height for the grid
 * @returns {string} Reconstructed document text
 */
export function reconstructDocumentContent(
  analyzeResult, 
  widthChars = DOCUMENT_RECONSTRUCTION.widthChars, 
  heightLines = DOCUMENT_RECONSTRUCTION.heightLines
) {  
  const outputLines = [];  
  const pages = analyzeResult.pages || [];  
  
  for (const page of pages) {  
    outputLines.push(
      ('Page ' + page.pageNumber).padStart(
        Math.floor((widthChars + ('Page ' + page.pageNumber).length) / 2), 
        ' '
      )
    );  
      
    const pageWidth = page.width;  
    const pageHeight = page.height;  
    const charPerInch = widthChars / pageWidth;  
    const linesPerInch = heightLines / pageHeight;  
      
    // Create blank grid  
    const grid = Array.from({length: heightLines}, () => Array(widthChars).fill(' '));  
      
    for (const line of page.lines) {  
      const xInch = line.polygon[0];  
      const yInch = line.polygon[1];  
      const col = Math.floor(xInch * charPerInch);  
      const row = Math.floor(yInch * linesPerInch);  
      const content = line.content;  
      
      for (let idx = 0; idx < content.length; idx++) {  
        const c = col + idx;  
        if (row >= 0 && row < heightLines && c >= 0 && c < widthChars) {  
          grid[row][c] = content[idx];  
        }  
      }  
    }  
      
    for (const gridLine of grid) {  
      const lineStr = gridLine.join('');  
      if (lineStr.trim()) {  
        outputLines.push(lineStr);  
      }  
    }  
      
    outputLines.push(
      ('End of Page ' + page.pageNumber).padStart(
        Math.floor((widthChars + ('End of Page ' + page.pageNumber).length) / 2), 
        ' '
      )
    );  
  }  
  
  return outputLines.join('\n');  
}

/**
 * Reads file as text
 * @param {File} file - The file to read
 * @returns {Promise<string>} File content as text
 */
export async function readFileAsText(file) {
  return await file.text();
}
